export enum Upstream {
  BLOG = 'blog',
  DJANGO = 'django',
  SSR = 'ssr',
  SSR_ROVER = 'ssr-rover',
}

export class UpstreamRedirect extends Error {
  upstream: Upstream;

  constructor(upstream: Upstream) {
    super();
    this.upstream = upstream;
  }
}
